export * from "/__w/wiggot-web/wiggot-web/packages/web-components/services/portals.services.ts"